/**
 * Signup & Create Post: Trade Categories (main) and Trade Subcategories (featured services).
 * Derived from admin Trade Categories sample data. Public-Facing Names are not used here.
 * No API — local spec data only for now.
 */
import { buildSampleTradeCategories } from '../sections/AdminDashboard/TradeCategories/tradeCategoriesDummyData';

function buildSignupCategoryData() {
  const mainCategories = [];
  /** @type {Record<string, string>} subcategory name → trade category name */
  const subToMain = {};
  /** @type {Record<string, Array<{ id: string, name: string }>>} trade category name → subs */
  const mainToSubs = {};
  /** API-shaped list used by signup / create-post Redux state */
  const serviceCategories = [];

  buildSampleTradeCategories().forEach((category) => {
    const mainName = category.name;
    mainCategories.push(mainName);

    const subs = (category.tradeSubcategories || []).map((s) => ({
      id: s.id,
      name: s.name,
      description: '',
      iconUrl: null,
      keywords: null,
    }));
    mainToSubs[mainName] = subs;

    subs.forEach((s) => {
      subToMain[s.name] = mainName;
    });

    serviceCategories.push({
      id: category.id,
      name: mainName,
      description: '',
      iconUrl: category.iconUrl || null,
      keywords: null,
      subcategories: subs,
    });
  });

  return { mainCategories, subToMain, mainToSubs, serviceCategories };
}

const { mainCategories, subToMain, mainToSubs, serviceCategories } =
  buildSignupCategoryData();

/** Trade Category names for the signup Trade Category dropdown (41). */
export const MAIN_CATEGORIES_SIGNUP = mainCategories;

/**
 * Trade Subcategory name → Trade Category name.
 */
export const SUB_TO_MAIN_MAPPING = subToMain;

/**
 * Trade Category name → Trade Subcategories (id + name) from admin data.
 */
export const MAIN_TO_SUBCATEGORIES_SIGNUP = mainToSubs;

/**
 * Full signup category list (Trade Categories + Trade Subcategories only).
 * Local spec data — no API.
 */
export const SIGNUP_SERVICE_CATEGORIES = serviceCategories;

/** Fresh copy of the local signup category list (safe to put in Redux). */
export function buildSignupServiceCategories() {
  return SIGNUP_SERVICE_CATEGORIES.map((category) => ({
    ...category,
    subcategories: (category.subcategories || []).map((s) => ({ ...s })),
  }));
}
